import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { CheckCircleOutlined } from '@mui/icons-material';
import {successBackgroundSx} from '../../../../common/styles/commonStyles'
import {
  Box,
  Typography,
  Fab,
  Slide
} from '@mui/material';

const Success = () => {
  return (
    <Slide in timeout={300} direction="down">
      <Box
        sx={{
          boxShadow: '0px 0px 25px rgba(0, 0, 0, 0.25)',
          display: 'flex',
          backgroundColor: '#fff',
          pb: 2.5,
          flexDirection: 'column',
          width: {
            xs: '100%',
            md: '80%'
          },
          mx: 'auto',
          borderRadius: '5px',
          position: 'relative'
        }}
      >
        <Box sx={successBackgroundSx}>
          <CheckCircleOutlined />

          <Typography variant="h1">
            Thanks for signing up.
          </Typography>
        </Box>

        <Box
          sx={{
            p: 5,
            textAlign: 'center',
            '& h6': {
              fontWeight: 500,
              pb: 1.25
            }
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: '#4EC1A5' }}
          >
            Hi John Smith MD
          </Typography>

          <Typography variant="body1">
            <br />
            An account activation email has been sent to Elcamino Medical
            Clinic registered email address. Please check your inbox and click
            on the link in the message to confirm and activate your account.
          </Typography>

          <br />

          <Fab
            variant="extended"
            size="medium"
            color="primary"
            aria-label="EHR Login"
            component={RouterLink}
            to="/sign-in"
            sx={{
              width: 'auto',
              mt: 2.5,
              px: '30px !important',
              py: '10px',
              lineHeight: '16px'
            }}
          >
            Click here for your EHR Login
          </Fab>
        </Box>
      </Box>
    </Slide>
  );
};

export default Success;